/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MessageRead } from '../../models/message-read';

export interface CreateMessageApiV1MessagePost$Params {
}

export function createMessageApiV1MessagePost(http: HttpClient, rootUrl: string, params?: CreateMessageApiV1MessagePost$Params, context?: HttpContext): Observable<StrictHttpResponse<MessageRead>> {
  const rb = new RequestBuilder(rootUrl, createMessageApiV1MessagePost.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MessageRead>;
    })
  );
}

createMessageApiV1MessagePost.PATH = '/api/v1/message';
